/**
 * The one chrome for MemoForm's size-6 icon buttons — the privacy toggle, the
 * owner-picker avatar trigger, and the composer's close "×". They sit side by
 * side in the same cluster, so their box, hover, focus and disabled treatments
 * must be byte-identical; three near-copies had already started to drift
 * (`cursor-pointer` on two of them, `disabled:` styles on two others).
 */
export const MEMO_ICON_BUTTON_CLASS =
  'inline-flex size-6 shrink-0 items-center justify-center rounded-md text-tertiary hover:bg-primary_hover hover:text-tertiary_hover disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer outline-focus-ring focus-visible:outline-2 focus-visible:outline-offset-2';
